module.exports = __webpack_public_path__ + "img/paci_ar_3.2d305ae1.png";